import React, { useEffect, useState } from "react";
import { useNavigate, useParams,useLocation } from "react-router-dom";
import Input from "../shared/Input";
import { fetchData, fetchFormData } from "../../utils/options";
import topTost from "../../utils/topTost";

const Lead_SourceCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [bank, setBank] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchDetails = async (id) => {
    try {
      const formData = new FormData();
      formData.append("id", id); // Send ID in the form data

      const result = await fetchFormData(
        "get-by-id-lead-source",
        formData,
        "POST"
      );
      if (result && result.data) {
        setBank(result.data.source_name);
      } else {
        console.warn("Bank data not found.");
        setBank("");
      }
    } catch (error) {
      console.error("Failed to fetch bank details:", error);
      setBank("");
    }
  };

  useEffect(() => {
    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Create a FormData object
    const formData = new FormData();
    formData.append("branchID", 1);
    formData.append("source_name", bank);
    formData.append("created_by", userId);
    formData.append("moduleId", M_id);
    try {
      let res;

      if (id) {
        formData.append("id", id);
        formData.append("userId", userId);
        // Edit logic - update
        res = await fetchFormData("update-lead-source", formData, "POST");
        console.log("Updating bank:", id, formData);
      } else {
        // Create logic - new
        res = await fetchFormData("add-lead-source", formData, "POST");
        console.log("Creating new bank:", formData);
      }

      if ((res && res.code === 200) || res.code === 201) {
        topTost({
          title: res?.message || "Operation successful",
          icon: "success",
        });
        navigate(`/master/inquiry-sources-list?id=${M_id}`);
      } else if (res && res.code === 422) {
        topTost({
          title: Array.isArray(res.message)
            ? res.message
            : res.message || "Validation error",
          icon: "error",
        });
      } else {
        console.error("Operation failed:", res);
        topTost({
          title: res?.message || "Something went wrong",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-5 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2">
                  {id ? "Edit inquiry Source:" : "Add inquiry Source:"}
                </span>
              </h5>
            </div>

            <form onSubmit={handleSubmit} className="row g-3">
              <div className="col-md-6">
                <Input
                  label="Inquiry Source Name"
                  name="Lead_Source_name"
                  value={bank}
                  onChange={(name, value) => setBank(value)}
                  placeholder="Inquiry Source Name"
                  icon="feather-hash"
                  required
                />
              </div>
              <div className="col-md-6">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Lead_SourceCreate;
